module.exports = __webpack_public_path__ + "media/images/icons/phone-ed3eaa714f6ba62d4bc8c0f3d970e2c4.svg";